import MainScript from '../main.js'
export default {
    name: 'DHome',
    mixins: [MainScript],
    data () {
        return {}
    },
  
    components: {},
    methods: {},
    created: function(){}
}


// WEBPACK FOOTER //
// ./src/pages/Timeline/desktop/script.js